
import Vue from 'vue'
import LanguageListItem from '~/components/language/ListItem.vue'
import { LanguageApi } from '~/apiclient/apifilters'
import Spinner from '~/components/_general/Spinner.vue'
import { GlobalSermonsLanguage } from '~/apiclient/apisermons'
import { PromiseAll } from '~/assets/ts/utils/misc'
import { createSiteSermonUrl } from '~/assets/ts/utils/urls'

interface GlobalLanguage {
  sermonUrl: string
  language: LanguageApi
}

export default Vue.extend({
  name: 'SiteSermonsGlobalSelectorDropdown',
  components: { Spinner, LanguageListItem },
  props: {
    sermonId: {
      type: String,
      required: true,
    },
    currentLanguage: {
      type: String,
      default: '',
    },
    close: {
      type: Function,
      required: true,
    },
  },
  computed: {
    globalLanguages(): GlobalSermonsLanguage[] {
      return this.$store.getters['sermons/globalLanguages'](this.sermonId) ?? []
    },
    languageOptions(): GlobalLanguage[] {
      if (!this.allLanguages.length) return []
      return this.globalLanguages
        .map((l) => {
          const language = this.allLanguages.find(
            (al) => al.languageCode3 === l.language
          )
          if (!language) return undefined
          return {
            sermonUrl: `${createSiteSermonUrl(l.sermonID)}?autoplay=1`,
            language,
          } as GlobalLanguage
        })
        .filter((l) => !!l)
    },
    allLanguages(): LanguageApi[] {
      return this.$store.getters['filters/languages'] ?? []
    },
  },
  async mounted() {
    await PromiseAll([
      this.$store.dispatch('sermons/fetchGlobalLanguages', {
        sermonID: this.sermonId,
      }),
      this.$store.dispatch('filters/getLanguages'),
    ])
  },
})
